var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cs from 'classnames';
import { Box } from '../box';
import styles from './paper.module.scss';
export var Paper = function (_a) {
    var _b;
    var _c = _a.isOverflowHidden, isOverflowHidden = _c === void 0 ? false : _c, className = _a.className, children = _a.children, rest = __rest(_a, ["isOverflowHidden", "className", "children"]);
    return (_jsx(Box, __assign({ className: cs(styles.paper, (_b = {}, _b[styles.overflowHidden] = isOverflowHidden, _b), className) }, rest, { children: children })));
};
